import { Container, Row, Col, Nav, NavLink } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  appSetup,
  getAllCategories,
  SocialLink,
} from "../../features/master/masterSlice";
import { useEffect } from "react";
import { getGroupByProduct } from "../../features/products/productsSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollAnimation from "react-animate-on-scroll";

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    // first navigate to Categories page
    dispatch(getGroupByProduct({ p_category_id: id }));
    // Wait a bit to let the Categories component mount
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // tweak delay if needed
    navigate(`/categories?category_id=${id}`, { state: { scrollToId: id } });
    // navigate(`/categories?category_id=${id}`);
  };

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const sociallink = useSelector((state) => state.master.social_link);

  useEffect(() => {
    dispatch(SocialLink());
  }, [dispatch]);

  const isSignin = useSelector((state) => state.auth.is_signin);

  const app_setup = useSelector((state) => state.master.app_setup);

  const location = useLocation();

  return (
    <>
      <section className="Footer">
        <div className="container">
          <div className="row custom_row ">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-10 col-sm-10">
              <div className="fisrt_col">
                <div className="logo_holder">
                  <img
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
                <p className="tag_line">
                  Your trusted source for premium herbal healthcare & organic
                  agro products. Nature's goodness delivered to your doorstep.
                </p>
              </div>
            </div>

            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-5 col-sm-6">
              <div className="col_div">
                <p className="footer_section_title">Quick Links</p>

                <Nav>
                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/"
                        className={location.pathname === "/" ? "active" : ""}
                      >
                        Home
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/shop"
                        className={
                          location.pathname === "/shop" ? "active" : ""
                        }
                      >
                        Categories
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/about-us"
                        className={
                          location.pathname === "/about-us" ? "active" : ""
                        }
                      >
                        About Us
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/blog"
                        className={
                          location.pathname === "/blog" ? "active" : ""
                        }
                      >
                        Blog
                      </NavLink>
                    </Nav.Item>

                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/contact-us"
                        className={
                          location.pathname === "/contact-us" ? "active" : ""
                        }
                      >
                        Contact Us
                      </NavLink>
                    </Nav.Item>
                  </div>

                  <div className="first_nav_div">
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/terms-conditions"
                        className={
                          location.pathname === "/terms-conditions"
                            ? "active"
                            : ""
                        }
                      >
                        Terms & Conditions
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/privacy-policy"
                        className={
                          location.pathname === "/privacy-policy"
                            ? "active"
                            : ""
                        }
                      >
                        Privacy Policy
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/account"
                        className={
                          location.pathname === "/account" ? "active" : ""
                        }
                      >
                        Your Account
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink
                        as={Link}
                        to="/wishlist"
                        className={
                          location.pathname === "/wishlist" ? "active" : ""
                        }
                      >
                        Your Wishlist
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink as={Link} to="/faqs">
                        FAQs
                      </NavLink>
                    </Nav.Item>
                  </div>
                </Nav>
              </div>
            </div>

            <div className="col-xxl-4 col-xl-3 col-lg-3 col-md-4 col-sm-6">
              <div className="col_div">
                <div className="footer_info_div">
                  <p className="footer_section_title">Customer Support</p>
                  <p className="info_text">
                    <span className="bold_text">Phone:</span>{" "}
                    {app_setup?.contact_no}
                  </p>
                  <p className="info_text">
                    <span className="bold_text">Email:</span> {app_setup?.email}
                  </p>
                </div>

                <div className="footer_info_div">
                  <p className="bold_text">Phone for Corporate Queries </p>
                  <p className="info_text">
                    Phone: {app_setup?.alt_contact_no}
                  </p>
                </div>

                <div className="footer_info_div">
                  <p className="bold_text">Address</p>
                  <p className="info_text">{app_setup?.address}</p>
                </div>
              </div>
            </div>

            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-3 col-sm-12">
              <div className="col_div">
                <p className="footer_section_title">Social Links</p>

                <div className="icons_holder">
                  {sociallink.map((item, index) => (
                    <div className="icon_div">
                      <a
                        key={index}
                        href={item?.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="img_holder"
                      >
                        <img
                          src={process.env.REACT_APP_IMG_URL + item?.image}
                          className="icon_class"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              ©2026 Gurukrupa Store All Rights Reserved | Developed by{" "}
              <Link to={"https://profcymaglobal.com/"} target="_blank">
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </div>
        </div>
      </section>

      {/* <footer className="Footer">
        <div className="container">
          <Row>
            <Col
              lg={3}
              sm={12}
              xs={12}
              className="footer-brand order-md-1 order-1"
            >
              <Link to="/" className="">
                <div className="logo_holder">
                  <img
                    src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
                    className="logo_img"
                  />
                </div>
              </Link>

              <div className="social-icons">
                {sociallink?.map((val) => (
                  <a
                    href={val?.url}
                    className="social-icon"
                    target="_blank"
                    rel="noopener noreferrer"
                    key={val?.id || val?.url}
                  >
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      className="social_icon_img"
                      alt="Social icon"
                    />
                  </a>
                ))}
              </div>
            </Col>
            <Col
              lg={3}
              sm={4}
              xs={6}
              className="footer-links order-md-2 order-3"
            >
              <h3>Categories</h3>
              <ul>
                {category?.map((val) => (
                  <li>
                    <a onClick={() => scrollToSection(val?.id)}>
                      <p>{val?.name}</p>
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
            <Col
              lg={3}
              sm={4}
              xs={6}
              className="footer-links order-md-3 order-4"
            >
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <Link to="/">
                    <p>Home</p>
                  </Link>
                </li>
                <li>
                  <Link to="/about-us">
                    <p>About Us</p>
                  </Link>
                </li>
                <li>
                  <Link to="/categories">
                    <p>Shop by Category</p>
                  </Link>
                </li>
                <li>
                  <Link to="/blog">
                    <p>Blog</p>
                  </Link>
                </li>
                <li>
                  <Link to="/contact">
                    <p>Contact Us</p>
                  </Link>
                </li>
                <li>
                  <Link to="/wallet">
                    <p>Wallet</p>
                  </Link>
                </li>
                <li>
                  <Link to="/terms">
                    <p>Terms & Conditions</p>
                  </Link>
                </li>
                <li>
                  <Link to="/privacy">
                    <p>Privacy Policy</p>
                  </Link>
                </li>
                {isSignin && (
                  <li>
                    <Link to="/account">
                      <p>Your Account</p>
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="/wishlist">
                    <p>Your Wishlist</p>
                  </Link>
                </li>
                <li>
                  <Link to="/faqs">
                    <p>FAQs</p>
                  </Link>
                </li>
              </ul>
            </Col>
            <Col
              lg={3}
              sm={4}
              xs={12}
              className="footer-links order-md-4 order-5"
            >
              <h3>Get in Touch</h3>

              <div className="contact-section">
                <h4>Customer Support</h4>
                <Link to={`mailto:${app_setup?.email}`} target="_blank">
                  <p>Email: {app_setup?.email}</p>
                </Link>
                <Link to={`tel:${app_setup?.contact_no}`} target="_blank">
                  <p>Phone: {app_setup?.contact_no}</p>
                </Link>
              </div>
              <div className="contact-section">
                <h4>Phone for Corporate Queries</h4>
                <Link to={`tel:${app_setup?.alt_contact_no}`} target="_blank">
                  <p>Phone: {app_setup?.alt_contact_no}</p>
                </Link>
              </div>
              <div className="contact-section">
                <h4>Address</h4>
                <p>
                  <b>Gurukrupa</b>
                </p>
                <p>{app_setup?.address}</p>
              </div>
            </Col>
          </Row>
        </div>
        <Row className="me-0 ms-0">
          <Col className="copyright">
            <p>
              ©2026 Gurukrupa. All Rights Reserved | Developed by{" "}
              <Link to={"https://profcymaglobal.com/"} target="_blank">
                Profcyma Solutions Pvt Ltd
              </Link>
            </p>
          </Col>
        </Row>
      </footer> */}
    </>
  );
};

export default Footer;
